import { CheckIcon } from "@phosphor-icons/react";
import { Flex } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { CSSProperties } from "react";
import { radius } from "@libertify/ui";

export const Checked = ({
  style,
  checkedSize = 40,
}: {
  style?: CSSProperties;
  checkedSize?: number;
}) => {
  const { theme } = useAntTheme();
  return (
    <Flex
      align="center"
      justify="center"
      data-testid="checked-icon"
      style={{
        position: "absolute",
        backgroundColor: theme.colorPrimary,
        width: checkedSize,
        height: checkedSize,
        border: `4px solid ${theme.colorBgElevated}`,
        borderRadius: radius.circle,
        color: theme.colorBgElevated,
        right: -checkedSize / 2,
        top: -checkedSize / 4,
        zIndex: 2,
        ...style,
      }}
    >
      <CheckIcon size={checkedSize / 3} weight="bold" />
    </Flex>
  );
};
